import styled from 'styled-components/macro';

import Typography from 'components/Typography/Typography';

type OptionStyledT = {
  isFocused: boolean;
  isSelected: boolean;
};

export const OptionStyled = styled.div<OptionStyledT>`
  padding: 8px 12px;
  color: ${({ theme, isSelected }): string =>
    isSelected ? theme.colors.white : theme.colors.primary.variant9};
  background-color: ${({ theme, isSelected }): string =>
    isSelected ? theme.colors.primary.variant1 : theme.colors.white};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme, isSelected }): string =>
      isSelected ? theme.colors.primary.variant1 : theme.colors.primary.variant3};
  }
`;

export const PlaceholderStyled = styled(Typography)`
  color: ${({ theme }): string => theme.colors.primary.variant8};
`;

export const ControlStyled = styled.div`
  display: flex;
  min-height: 38px;
  background-color: ${({ theme }): string => theme.colors.white};
  border-radius: ${({ theme }): string => theme.radius.sm};
  transition: 0.1s;
`;

export const LabelStyled = styled.label`
  display: block;
  margin-bottom: 0.25rem;
  color: ${({ theme }): string => theme.colors.primary.variant9};
`;

export const RequiredSignStyled = styled.span`
  color: ${({ theme }): string => theme.colors.highlight.variant2};
`;
